<template>
  <transition name="toast-fade">
    <div v-if="isVisible" class="toast-container" :class="type">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: "Toast",
  props: {
    message: String,
    type: {
      type: String,
      default: "info",
    },
    duration: {
      type: Number,
      default: 3000,
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    this.showToast();
  },
  methods: {
    showToast(isVisible) {
      this.isVisible = !!isVisible;
      setTimeout(() => {
        this.isVisible = false;
      }, this.duration);
    },
  },
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #35495e;
  color: white;
  padding: 10px 15px;
  border-radius: 4px;
  z-index: 1000;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.5s;
}

.toast-fade-enter, .toast-fade-leave-to /* .fade-leave-active for <2.1.8 */ {
  opacity: 0;
}
</style>
